(() => {
  const root = document.querySelector('[data-atd-ph]');
  if (!root) return;

  // Desktop cards – future-proof click handler
  root.querySelectorAll('.atd-ph__card').forEach(card => {
    card.addEventListener('click', () => {
      const key = card.getAttribute('data-ph');
      // Hook your action/analytics here
      // console.log('desktop highlight clicked:', key);
    });
  });

  // Mobile – only info buttons are clickable
  root.querySelectorAll('.atd-ph__info-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const key = btn.getAttribute('data-ph');
      // Hook your action (open modal / tooltip / drawer) here
      // console.log('mobile info clicked:', key);
    });
  });
})();
